import MessageItemMobile from 'components/MessageItemMobile';
import React from 'react';

export function MobilePage() {
  return <MessageItemMobile />;
}
